module.exports = __webpack_public_path__ + "media/src/website/images/sponsors/zweirad-schroeck-532a86c072f1795cec87954bb2cc8c7f.jpg";